<template>
    <div v-if="options_loaded && passed_filter" :data-designer-component-id="component_id" class="designeroption">
        <h3>{{ title }}</h3>
        <div class="stylesoption">
            <div class="addonoption">
                <table>
                    <tbody>
                        <tr>
                            <td width="25%">&nbsp;</td>
                            <td width="25%">Left</td>
                            <td width="25%">Top</td>
                            <td width="25%">Right</td>
                        </tr>
                        <tr>
                            <td>
                                Please Select:
                            </td>
                            <td>
                              <span>
                                <select class="form-control addons" v-model="selected_addons.left">
                                  <option :value="{}">None</option>
                                  <option v-for="option in filtered_option_list" :value="{ [option.value] : 1 }">{{option.label}}</option>
                                </select>
                              </span>
                            </td>
                            <td>
                              <span>
                                <select class="form-control addons" v-model="selected_addons.top">
                                  <option :value="{}">None</option>
                                  <option v-for="option in filtered_option_list" :value="{ [option.value] : 1 }">{{option.label}}</option>
                                </select>
                              </span>
                            </td>
                            <td>
                              <span>
                                <select class="form-control addons" v-model="selected_addons.right">
                                  <option :value="{}">None</option>
                                  <option v-for="option in filtered_option_list" :value="{ [option.value] : 1 }">{{option.label}}</option>
                                </select>
                              </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionsAddons from "../DesignerQuestionsAddons.vue";

    export default {
        data() {
            return {
              selected_addons: {
                left: {},
                top: {},
                right: {},
              },
            }
        },
        mixins: [
            DesignerQuestionsAddons
        ],
        mounted(){
          for (var propertyName in this.localTarget) {
            if (Array.isArray(this.localTarget[propertyName])){
              this.localTarget[propertyName] = {};
            }
          }

          this.selected_addons = this.localTarget;
        },
        props: {
            frameStyle: {
                required: true
            }
        },
        methods: {
            allow_more_top_addons(val) {
                if(!this.has_left && !this.has_right){
                    return true;
                }
                if(this.localTarget.top[val] > 0) {
                    return true;
                }
                return this.sumValues(this.localTarget.top) < 1;
            },
            sumValues(obj){
                if(obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype){
                    return 0;
                }
                return Object.values(obj).reduce((a, b) => a + b);
            }
        },
        computed: {
            has_left(){
                return this.frameStyle.checkedPanels.indexOf("left") !== -1;
            },
            has_right(){
                return this.frameStyle.checkedPanels.indexOf("right") !== -1;
            },
        },
      watch: {
        selected_addons: {
          handler: function (val, oldVal) {
              this.localTarget.left = val.left;
              this.localTarget.top = val.top;
              this.localTarget.right = val.right;
          },
          deep: true,
        },
      }
    }
</script>
